import * as React from "react";
import styles from './SideBar.sass'
import { Game } from "../game/Game";
import { BeeType } from "../game/BeeType";
import { Bees, CoolDownBehaviour } from "../game/Bees";

const BeeIcon = (props: { type: BeeType }) => {
	const tex = Bees[props.type as BeeType].textureCoords;
	return < div
		className={styles.bee}
		style={{ backgroundPosition: `${-tex.x * 32}px ${-tex.y * 32}px ` }
		}>
	</div >
}

export const SideBar = (props: { game: Game }) => {
	const bees = Object.entries(props.game.player.bees)
		.map(([type, count]) => [...Array(count)].map(a => ({
			type
		}))).flat();
	const meleeCooldown = Bees.MeleeBee.behaviours?.find(b => b instanceof CoolDownBehaviour)?.getCooldownPercent() ?? 0
	const dashCooldown = Bees.DashBee.behaviours?.find(b => b instanceof CoolDownBehaviour)?.getCooldownPercent() ?? 0
	const bulletCooldown = Bees.BulletBee.behaviours?.find(b => b instanceof CoolDownBehaviour)?.getCooldownPercent() ?? 0

	if (props.game.over) {
		return <div className={styles.sideBar}></div>
	}

	return <div className={styles.sideBar}>
		<div>
			Swarm
		</div>
		<div className={styles.swarm}>
			{
				bees.map((bee, i) =>
					<BeeIcon
						key={`${bee.type}:${i}`}
						type={bee.type as BeeType}>
					</BeeIcon>
				)
			}
		</div>
		<div className={styles.separator}></div>
		{props.game.player.bees.DiesFirstBee > 0 && <div className={styles.ability}>
			<div className={styles.cooldown} style={{
				right: `0%`,
				backgroundColor: 'rgb(62,64,61, 1)'
			}}></div>
			<div className={styles.header}>
				<BeeIcon
					type={BeeType.DiesFirstBee}>
				</BeeIcon>
				<div className={styles.text}>Defender</div>
			</div>
		</div>}
		{props.game.player.bees.MeleeBee > 0 && <div className={styles.ability}>
			<div className={styles.cooldown} style={{
				right: `${100 - meleeCooldown * 100}%`,
				backgroundColor: `${meleeCooldown >= 1 ? 'rgb(62,64,61, 1)' : 'rgba(62,64,61,0.5)'}`
			}}></div>
			<div className={styles.header}>
				<BeeIcon
					type={BeeType.MeleeBee}>
				</BeeIcon>
				<div className={styles.key}>SPACE</div>
				<div className={styles.text}>Melee Attack</div>
			</div>
		</div>}
		{props.game.player.bees.DashBee > 0 && <div className={styles.ability}>
			<div className={styles.cooldown} style={{
				right: `${100 - dashCooldown * 100}%`,
				backgroundColor: `${dashCooldown >= 1 ? 'rgb(62,64,61, 1)' : 'rgba(62,64,61,0.5)'}`
			}}></div>
			<div className={styles.header}>
				<BeeIcon
					type={BeeType.DashBee}>
				</BeeIcon>
				<div className={styles.key}>SHIFT</div>
				<div className={styles.text}>Dash</div>
			</div>
		</div>}
		{props.game.player.bees.BulletBee > 0 && <div className={styles.ability}>
			<div className={styles.cooldown} style={{
				right: `${100 - bulletCooldown * 100}%`,
				backgroundColor: `${bulletCooldown >= 1 ? 'rgb(62,64,61, 1)' : 'rgba(62,64,61,0.5)'}`
			}}></div>
			<div className={styles.header}>
				<BeeIcon
					type={BeeType.BulletBee}>
				</BeeIcon>
				<div className={styles.key}>CLICK</div>
				<div className={styles.text}>Shoot</div>
			</div>
		</div>}
	</div >;
}
